import { FC, PropsWithChildren, useLayoutEffect, useRef, useState } from 'react';
import { PanelResizeHandle, PanelResizeHandleOnDragging } from 'react-resizable-panels';

export interface ResizeHandleProps {
  e2e?: string;
  onDragging?: PanelResizeHandleOnDragging;
}

export const ResizeHandle: FC<PropsWithChildren<ResizeHandleProps>> = ({ children, e2e, onDragging }) => {
  const badgeRef = useRef<HTMLDivElement>(null);
  const [badgeHeight, setBadgeHeight] = useState(0);

  useLayoutEffect(() => {
    if (badgeRef.current) {
      setBadgeHeight(badgeRef.current.offsetHeight);
    }
  }, []);

  return (
    <div className="position-relative">
      <PanelResizeHandle
        onDragging={onDragging}
        className="d-flex position-absolute w-100"
        style={{ top: -badgeHeight + 3 }} // adjust offset (+3) for the resize handle to avoid overlapping with upper(blotter) component
      >
        <div className="flex-grow-1 border-bottom" style={{ cursor: 'ns-resize' }} />
        <div data-e2e={e2e} ref={badgeRef} className="bg-lvl1 border border-bottom-0" style={{ zIndex: 3 }}>
          {children}
        </div>
        <div className="flex-grow-1 border-bottom" style={{ cursor: 'ns-resize' }} />
      </PanelResizeHandle>
    </div>
  );
};
